import useSWR from "swr";
import {
  authFetcher,
  fetcher,
  fetchWithAuth,
  FILTER_URL,
} from "./const.routes.ts";
import { FilterType } from "../types/Filter";
import { Result } from "../types/Result.ts";

export function useFilter(id: string, fallback: FilterType) {
  const { data, error, isLoading } = useSWR<FilterType>(
    FILTER_URL + id,
    fetcher,
    { keepPreviousData: true, revalidateIfStale: false },
  );
  return {
    filter: data ? data : fallback,
    isLoading,
    isError: error,
  };
}

export function useFilterIds(fallback: []) {
  const { data, error, isLoading } = useSWR<string[]>(FILTER_URL, authFetcher);
  return {
    filterIds: data ? data : fallback,
    isLoading,
    isError: error,
  };
}

export async function putFilter(
  filter: FilterType,
): Promise<Result<FilterType, string>> {
  try {
    const response = await fetchWithAuth(FILTER_URL, {
      method: "put",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(filter),
    });
    if (response.ok) {
      const attr: FilterType = await response.json();
      return { ok: true, value: attr };
    } else {
      switch (response.status) {
        case 404:
          return { ok: false, error: "Attribute put failed" };
        default:
          return { ok: false, error: "Unspecified error:" + response.status };
      }
    }
  } catch (e) {
    return {
      ok: false,
      error: "Unexpected error while putting Attribute: " + e,
    };
  }
}

export async function postFilter(
  attribute: Partial<FilterType>,
): Promise<Result<FilterType, string>> {
  try {
    const response = await fetchWithAuth(FILTER_URL, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(attribute),
    });
    if (response.ok) {
      const attr: FilterType = await response.json();
      return { ok: true, value: attr };
    } else {
      switch (response.status) {
        case 404:
          return { ok: false, error: "Attribute put failed" };
        default:
          return { ok: false, error: "Unspecified error:" + response.status };
      }
    }
  } catch (e) {
    return {
      ok: false,
      error: "Unexpected error while putting Attribute: " + e,
    };
  }
}
